

const HeaderRepwise = ({ handleLogout, navigateto, useremail }) => {
    return (
        <div className="header-container ">

            <h3 className='logo'>REPWISE</h3>

            <div style={{ display: 'flex', gap: '1rem' }}>
                <button className="tertiary-button" onClick={handleLogout}>Logout {useremail}</button>
                <button className="tertiary-button" onClick={() => navigateto('/DBtester')}>DB Tester</button>
            </div>

        </div>
    );
}

export default HeaderRepwise;